import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// Value stored for the "Other / not listed" choice. It intentionally matches no
// row in lca_supplier_location_factors, so the emissions calculator applies zero
// manufacturing uplift (the same as the old "unknown location" behaviour).
export const OTHER_COUNTRY = 'Other';

// The factor countries, with `current` prepended if it's a stored value that
// isn't one of them (e.g. legacy/imported data) — so it stays selectable instead
// of silently disappearing. Caller renders these as <option>s and appends an
// "Other / not listed" option separately.
export function countryOptionsWith(current, supplierCountries) {
  const value = (current || '').trim();
  if (value && value !== OTHER_COUNTRY && !supplierCountries.includes(value)) {
    return [value, ...supplierCountries];
  }
  return supplierCountries;
}

// Country-of-origin options = the countries that have a manufacturing-emissions
// uplift factor (lca_supplier_location_factors), fetched from the DB so the list
// always reflects the factors we actually hold. Anything else is "Other".
export function useSupplierLocations() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/lca/supplier-locations`);
        const list = (Array.isArray(data?.data) ? data.data : [])
          .map((l) => l.country)
          .filter(Boolean);
        if (active) setCountries(list);
      } catch (e) {
        if (active) setCountries([]);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return countries;
}
